import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  // The caret is an inline SVG on `currentColor`, so it follows this rule
  // rather than carrying a colour of its own.
  topMenu: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    color: theme.palette.common.gray800,
    '& p': {
      color: theme.palette.common.gray800,
    },
    '& span': {
      color: theme.palette.common.gray800,
    },
    height: '100%',
    '&:hover': {
      background: 'none',
      color: theme.palette.common.blue400,
      '& span': {
        color: theme.palette.common.blue400,
      },
      '& p': {
        color: theme.palette.common.blue400,
      },
    },
  },
  active: {
    borderBottom: `${theme.spacing(0.5)}px solid ${
      theme.palette.common.blue400
    }`,
    borderTop: `${theme.spacing(0.5)}px solid transparent`,
    '& p': {
      color: theme.palette.common.gray800,
      fontFamily: theme.typography.h4.fontFamily,
      fontWeight: 500,
    },
    '& span': {
      color: theme.palette.common.gray800,
      fontFamily: theme.typography.h4.fontFamily,
      fontWeight: 500,
    },
  },
  menuItem: null,
  arrowIcon: {
    marginLeft: theme.spacing(1),
    transform: props => props.isOpen && 'rotate(180deg)',
    transition: 'transform 250ms linear',
  },
  leftSectionTrigger: {
    color: theme.palette.common.gray800,
    '&:hover': {
      color: theme.palette.common.blue400,
    },
    '&$menuItem': {
      marginRight: theme.spacing(0.5),
    },
  },
  menuList: {
    '&.MuiMenu-list': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  root: {
    '&$selected': {
      '& span': {
        color: theme.palette.common.blue400,
      },
      '&:hover': {
        backgroundColor: theme.palette.common.brandSelectedHover,
      },
      '& p': {
        color: theme.palette.common.blue400,
      },
      backgroundColor: theme.palette.common.brandTint,
      borderRadius: '5px',
    },
    '&:hover': {
      backgroundColor: theme.palette.common.gray100,
    },
  },
}));

export default useStyles;
